module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"omitted_count":"他{0}点の商品","write_review":"レビューを書きに行く"}}')
  delete Component.options._Ctor
}
